/* * @Author: Wei Guojun * @Date: 2021-04-22 09:00:41 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-12-20 15:07:24 */
<template>
  <el-form
    :model="collect"
    :rules="rules"
    ref="editCollect"
    label-width="100px"
    class="demo-ruleForm"
  >
    <div class="from">
      <el-row v-show="this.addOredit.type == 'add'">
        <el-col class="title" :span="3">
          <div>一键粘贴</div>
        </el-col>
        <el-col :span="21">
          <div class="flexBetween">
            <el-input
              type="textarea"
              placeholder="(可支持多条换行符隔开)示例： 张三 18888888888 上海 上海市 黄浦区 延安东路888号88室 "
              v-model="collect.analysis"
              clearable
            >
            </el-input>
            <el-button
              class="parse"
              @click="doAnalysis(collect.analysis)"
              :loading="collect.isAnalysis"
              slot="append"
              >解析</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>
            <el-row>
              <el-col class="title" :span="6">
                <div>{{ addOredit.name }}姓名</div>
              </el-col>
              <el-col class="input" :span="18">
                <div>
                  <el-form-item prop="name">
                    <el-input
                      placeholder="请输入姓名"
                      suffix-icon="el-icon-user"
                      v-model="collect.name"
                      clearable
                    ></el-input>
                    <span class="span">*</span>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-row>
              <el-col class="title" :span="5">
                <div>联系方式</div>
              </el-col>
              <el-col class="input" :span="19">
                <div>
                  <el-form-item prop="phone">
                    <el-input
                      type="text"
                      placeholder="请输入联系手机或电话"
                      v-model.trim="collect.phone"
                      suffix-icon="el-icon-phone-outline"
                      clearable
                    ></el-input>
                    <span class="span">*</span>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 15px">
        <el-col :span="12">
          <div>
            <el-row>
              <el-col class="title" :span="6">
                <div>省/市/区</div>
              </el-col>
              <el-col class="input" :span="18">
                <div>
                  <el-form-item prop="pca">
                    <el-cascader
                      @change="changeAddress('collect')"
                      ref="collect"
                      :options="sender_address"
                      v-model="collect.pca"
                      placeholder="请选择省/市/区"
                      filterable
                    ></el-cascader>
                    <span class="span">*</span>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-row>
              <el-col class="title" :span="5">
                <div>详细地址</div>
              </el-col>
              <el-col class="input" :span="19">
                <div>
                  <el-form-item prop="address">
                    <el-input
                      type="text"
                      placeholder="请输入详细地址"
                      suffix-icon="el-icon-map-location"
                      v-model.trim="collect.address"
                      clearable
                    ></el-input>
                    <span class="span">*</span>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="btnList">
      <el-button plain @click="$parent.$parent.collectShow = false"
        >取消</el-button
      >
      <el-button type="primary" style="margin-left: 40px" @click="save">{{
        addOredit.type == "edit" ? "保存修改" : "保存信息"
      }}</el-button>
    </div>
  </el-form>
</template>
<script>
import util from "@/util/util.js";
import home from "@/api/home.js";
export default {
  name: "editAddress",
  props: ["editObj", "addOredit"],
  data() {
    var checkPhone = (rule, value, callback) => {
      const telReg = /^(400|800)(-)?[016789]\d{2}(-)?\d{4}$/g;
      const ghReg = /^\d{3,4}(-)?\d{7,8}$/g;
      const phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/g;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if ((value.length>=11&&value.length<=16) || telReg.test(value) || phoneReg.test(value) || ghReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }, 100);
    };
    return {
      sender_address: [],
      collect: {
        id: "",
        save_info: false, // 是否保存信息
        analysis: "", // 解析数据
        isAnalysis: false,
        name: "", // 姓名
        phone: "", // 手机号
        province: "", // 省
        province_code: "", //省编码
        city: "", // 市
        city_code: "", //市编码
        city_list: [], // 市列表
        area: "",
        area_code: "", //区编码
        area_list: [], //区列表
        address: "", // 详细地址
        pca: "", // 省市区
        type: "", //类型
        address_type: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写收件人姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "姓名长度在 1到 10个字符",
            trigger: "blur",
          },
        ],
        phone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        pca: [
          {
            required: true,
            message: "请选择省市区",
            trigger: "change",
          },
        ],
        province: [
          {
            required: true,
            message: "省不能为空",
            trigger: "change",
          },
        ],
        province_code: [
          {
            required: true,
            message: "省不能为空",
            trigger: "change",
          },
        ],
        city: [
          {
            required: true,
            message: "市不能为空",
            trigger: "change",
          },
        ],
        city_code: [
          {
            required: true,
            message: "市不能为空",
            trigger: "change",
          },
        ],
        area: [
          {
            required: true,
            message: "区不能为空",
            trigger: "change",
          },
        ],
        area_code: [
          {
            required: true,
            message: "区不能为空",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur",
          },
          {
            min: 3,
            max: 54,
            message: "详细地址需在3-54个字之间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created: function () {
    console.log(this.editObj);
    this.collect.address_type = this.editObj.address_type || "";
    this.collect.id = this.editObj.id || "";
    this.collect.address = this.editObj.address || "";
    this.collect.area_code = this.editObj.district_code || "";
    this.collect.city = this.editObj.city_name || "";
    this.collect.city_code = this.editObj.city_code || "";
    this.collect.name = this.editObj.name || "";
    this.collect.phone = this.editObj.phone || "";
    this.collect.province = this.editObj.province_name || "";
    this.collect.province_code = this.editObj.province_code || "";
    this.collect.area = this.editObj.district_name || "";
    if(this.addOredit.from == 'home'){
     this.collect.pca = this.editObj.pca
    }else{
     this.collect.pca = [this.collect.province_code,this.collect.city_code,this.collect.area_code];     
    }
  },
  mounted() {
     this.sender_address = this.ysbAddressFile.getcity()
  },
  methods: {
    // deepArray(param) {
    //   let newArr = param;
    //   newArr.sort((item1, item2) => item1.label.localeCompare(item2.label));
    //   //   debugger;
    //   newArr.forEach((element) => {
    //     element.children &&
    //       (element.children = this.deepArray(element.children));
    //   });
    //   return newArr;
    // },
    /** 解析绑定地址 */
    doAnalysis(analysis) {
      let self = this;
      if (!self.collect.analysis) {
        self.$message({
          type: "warning",
          message: "请填写解析内容",
        });
        return;
      }
      // self.$showLoading();
      self.collect.isAnalysis = true;
      home.doAnalysis(self, analysis).then((res) => {
        console.log('111')
        self.collect.isAnalysis = false;
        if (res.success) {          
          if (res.data.length == 1) {
            let data = res.data[0];
            self.collect.pca = [
              data.province_code,
              data.city_code,
              data.district_code,
            ];
            self.collect.name = data.name;
            self.collect.phone = data.phone;
            self.collect.province = data.province_name;
            self.collect.city = data.city_name;
            self.collect.area = data.district_name;
            self.collect.province_code = data.province_code;
            self.collect.city_code = data.city_code;
            self.collect.area_code = data.district_code;
            self.collect.address = data.address;
          }
        }
        if (res.data.length > 1) {
          self.$parent.$parent.copyText = self.collect.analysis;
          self.$parent.$parent.anslsList = res.data;
          self.$parent.$parent.fitInit();
          self.$parent.$parent.collectShow = false;
          self.$parent.$parent.moreVisble = true;
        }
      });
    },
    /** 选择地址 */
    changeAddress() {
      let address = this.$refs.collect.getCheckedNodes()[0].pathLabels; // 地址显示
      let code = this.$refs.collect.getCheckedNodes()[0].path; // 地区编码
      this.collect.province = address[0];
      this.collect.province_code = code[0];
      this.collect.city = address[1];
      this.collect.city_code = code[1];
      this.collect.area = address[2];
      this.collect.area_code = code[2];
    },
    //收件人信息编辑
    save() {
      this.$refs.editCollect.validate((valid) => {
        if (valid) {
          let data = {
            account_id: util.getCookie("account_id"),
            address: this.collect.address,
            city_code: this.collect.city_code,
            district_code: this.collect.area_code,
            id: this.collect.id,
            name: this.collect.name,
            phone: this.collect.phone,
            province_code: this.collect.province_code,
          };
          let words = [{'index':0,'origin_words':util.trimAll(data.address)}]
          home.sensitivewords(this,words).then(res=>{
            if(res.success){
              const resultArr = res.data;
              let filwordsArr = resultArr.filter(el=> el.hit_sensitive == 1)
              if(filwordsArr.length){
                this.collect.address = resultArr[0].sensitive_words;
                data.address = resultArr[0].sensitive_words;
                this.$confirm("您输入的信息中含有敏感词请修改后重新操作点击忽略订单中将以“□”代替", '提示', {
                  confirmButtonText: '忽略',
                  cancelButtonText: '去修改',
                  type: 'warning'
                }).then(() => {
                  this.save_next(data);
                }).catch(() => {         
                });
              }else{
                this.save_next(data);
              }
            } 
          })

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //拆分地址保存
    save_next(data){
      if (this.addOredit.type == "add") {
        data.address_type = this.addOredit.name == "收件人" ? 0 : 1;
        delete data.id;
        home.createAddress(this, data).then((res) => {
          if (res.success) {
            this.$message.success("联系人信息新增成功!");
            this.$parent.$parent.collectShow = false;
            this.$parent.$parent.loadmore();
          }
        });
      } else {
        if(this.addOredit.from == 'home'){
          const query = {
            account_id: util.getCookie("account_id"),
            address: this.collect.address,
            city_code: this.collect.pca[1],
            district_code: this.collect.pca[2],
            id: this.collect.id,
            name: this.collect.name,
            phone: this.collect.phone,
            province_code: this.collect.pca[0],
            address_type:0,
          }
          home.createAddress(this, query).then((res) => {
            if (res.success) {
              this.$message.success("联系人信息编辑成功!");
              const addressItem = {
                address:this.collect.address,
                analysis:'',
                area:this.collect.area || this.editObj.area || '',
                area_code:this.collect.area_code || this.editObj.area_code || '',
                city:this.collect.city || this.editObj.city || '',
                city_code:this.collect.city_code || this.editObj.city_code || '',
                name:this.collect.name,
                pca:this.collect.pca,
                phone:this.collect.phone,
                province:this.collect.province || this.editObj.province || '',
                province_code:this.collect.province_code || this.editObj.province_code || '',
                status_desc:'正常'
              }  
              this.$parent.$parent.Added_Collect[this.editObj.index] = addressItem;
              this.$parent.$parent.collectShow = false;
            }
          }); 
        }else{
          (data.address_type = this.editObj.address_type),
          home.updateAddress(this, data).then((res) => {
            if (res.success) {
              this.$message.success("联系人信息编辑成功!");
              this.$parent.$parent.collectShow = false;
              this.$parent.$parent.loadmore();
            }
          });          
        }
      }
    }
  },
};
</script>
<style lang="stylus" scoped>
.from {
  padding: 30px 40px 15px 40px;

  >.el-row {
    margin-bottom: 30px;
  }
  .flexBetween{
    display: flex;
    justify-content: space-between;
  }
  .el-row {
    display: flex;
    align-items: center;
    font-size: 16px;

    .title {
      text-align: right;
      margin-right: 10px;
      color: #212121;
    }

    .input {
      /deep/ .el-form-item {
        margin-bottom: 0;

        .el-input {
          width: 97%;
          float: left;
        }

        .el-form-item__content {
          margin: 0 !important;
        }
      }

      .el-cascader {
        width: 97%;
        float: left;

        // margin-right:10px;
        /deep/.el-input {
          width: 100% !important;
        }
      }

      .el-select {
        width: 97%;
        float: left;

        /deep/.el-input {
          width: 100% !important;
        }
      }

      .span {
        color: #FF0000;
        font-size: 14px;
        float: right;
      }
    }
  }

  .checkbox {
    margin-left: 110px;
  }

  .parse {
    background: #1C8BF6;
    color: #fff;
    border-radius: 0 4px 4px 0;
  }
}
.btnList{
    text-align center
    padding-top:20px
    /deep/ .el-button {
        width 100px
    }
}
</style>
